export const NOTIFICATION_STYLES = {
  tour: {
    color: "#7C5CFC",
    background: "#F3F0FF",
    border: "#DDD5FF",
  },

  update: {
    color: "#52616B",
    background: "#F3F6F8",
    border: "#E2E8EC",
  },
};

export const TAG_STYLES = {
  New: {
    color: "#2E8B57",
    background: "#EAF7EF",
    border: "#C8EBD5",
  },

  Improvement: {
    color: "#3478C9",
    background: "#EDF5FF",
    border: "#CFE2FA",
  },

  "Bug Fix": {
    color: "#D97706",
    background: "#FFF7E8",
    border: "#F6D9A8",
  },

  "Coming soon": {
    color: "#8B5CF6",
    background: "#F4F0FF",
    border: "#DDD2FA",
  },
};